import { useMutation } from '@tanstack/react-query';
import clientRequest from '@/lib/client-request';
import { PreTranslateInfo } from '@/app/services/translation';

export function useUploadFile() {
  const { mutate, isPending } = useMutation({
    mutationKey: ['upload-file'],
    mutationFn: async ({
      file,
      fileUrl,
      onUploadProgress,
      onClientUploadComplete,
    }: {
      file?: File;
      fileUrl?: string;
      onUploadProgress?: (uploadProgress: number) => void;
      onClientUploadComplete?: (data: PreTranslateInfo) => void;
    }) => {
      const formData = new FormData();
      if (file) {
        formData.append('file', file);
      }
      if (fileUrl) {
        formData.append('file_url', fileUrl);
      }
      const response = await clientRequest.post(
        '/file_translation/pre_translate',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            responseType: 'blob',
          },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const uploadProgress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );

              onUploadProgress && onUploadProgress(uploadProgress);
            }
          },
        },
      );
      const { data } = response;
      onClientUploadComplete && onClientUploadComplete(data);

      return data;
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { uploadFile: mutate, isUploading: isPending };
}
